import React from "react";
import axios from "axios";
import { useParams, useHistory } from "react-router-dom";

import { Shelf as ShelfComponent } from "components/shelf/Shelf";
import { Form } from "components/shelf/Form";
import { Details } from "components/shelf/Details";

import { env } from "const";

export function Shelf() {
  const [state, dispatch] = React.useReducer(
    (s, action) => {
      switch (action.type) {
        case "FETCH_SUCCESS":
          return {
            ...s,
            highlights: action.highlights
              .filter((h) => h.id !== env.TOP_HIGHLIGHT_ID)
              .map((h) => {
                return {
                  ...h,
                  rank: h.rank[0].rank,
                };
              }),
            reorderHighlights: action.highlights
              .filter((h) => h.id !== env.TOP_HIGHLIGHT_ID)
              .map((h) => {
                return {
                  ...h,
                  rank: h.rank[0].rank,
                };
              }),
            isProcessing: false,
            isError: false,
          };
        case "FETCH_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "REORDER_CLICKED":
          return {
            ...s,
            showReorder: true,
          };
        case "REORDER_CANCEL":
          return {
            ...s,
            showReorder: false,
          };
        case "UP_ORDER_CLICKED":
          const newHighlights = reorder(
            action.highlight,
            action.nextRank,
            s.reorderHighlights
          );
          return {
            ...s,
            reorderHighlights: newHighlights,
          };
        case "DOWN_ORDER_CLICKED":
          const orderedHighlights = reorder(
            action.highlight,
            action.nextRank,
            s.reorderHighlights
          );
          return {
            ...s,
            reorderHighlights: orderedHighlights,
          };
        case "SAVE_ORDER":
          console.log(action);
          return {
            ...s,
            isProcessing: true,
            isError: false,
          };
        case "SAVE_ORDER_SUCCESS":
          return {
            ...s,
            highlights: s.reorderHighlights.slice(),
            isProcessing: false,
            isError: false,
            showReorder: false,
          };
        case "SAVE_ORDER_ERROR":
          console.log(action.error);
          return {
            ...s,
            isError: true,
            isProcessing: false,
          };
        case "DELETE_SUCCESS":
          return {
            ...s,
          };
        case "DELETE_ERROR":
          console.log(action.error);
          return {
            ...s,
            isError: true,
          };
        default:
          return s;
      }
    },
    {
      highlights: [],
      reorderHighlights: [],
      showReorder: false,
      isProcessing: true,
      isError: false,
    }
  );
  React.useEffect(() => {
    const f = async () => {
      try {
        const responses = await fetchShelfPageData();
        dispatch({
          type: "FETCH_SUCCESS",
          highlights: responses[0].data,
        });
      } catch (e) {
        console.error(e);
        dispatch({
          type: "FETCH_ERROR",
        });
      }
    };

    f();
  }, []);

  const onSaveReorder = async () => {
    try {
      await updateHighlightOrder(state.reorderHighlights);
      dispatch({ type: "SAVE_ORDER_SUCCESS" });
    } catch (e) {
      console.error(e);
      dispatch({ type: "SAVE_ORDER_ERROR", error: e });
    }
  };
  const onDeleteHighlight = async (id) => {
    try {
      await deleteHighlight(id);
      const responses = await fetchShelfPageData();
      dispatch({
        type: "FETCH_SUCCESS",
        highlights: responses[0].data,
      });
    } catch (error) {
      dispatch({ type: "DELETE_ERROR", error });
    }
  };
  return (
    <ShelfComponent
      highlights={state.highlights}
      reorderHighlights={state.reorderHighlights}
      showReorder={state.showReorder}
      onDeleteHighlight={onDeleteHighlight}
      onReorderClick={() => {
        dispatch({ type: "REORDER_CLICKED" });
      }}
      onReorderCancelClick={() => {
        dispatch({ type: "REORDER_CANCEL" });
      }}
      onUpOrderClick={(highlight, nextRank) => {
        dispatch({ type: "UP_ORDER_CLICKED", highlight, nextRank });
      }}
      onDownOrderClick={(highlight, nextRank) => {
        dispatch({ type: "DOWN_ORDER_CLICKED", highlight, nextRank });
      }}
      onSaveOrderClick={onSaveReorder}
    />
  );
}

export function HighlightForm() {
  const history = useHistory();
  const [state, dispatch] = React.useReducer(
    (s, action) => {
      switch (action.type) {
        case "FETCH_SUCCESS":
          return {
            ...s,
            category: action.categoryList[0].title,
            categoryList: action.categoryList,
            programList: action.programList,
            isProcessing: false,
            isError: false,
          };
        case "FETCH_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "ADD_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: [...s.pickedProgramList, action.program],
            programList: s.programList.filter(
              (p) => p.id !== action.program.id
            ),
          };
        case "REMOVE_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: s.pickedProgramList.filter(
              (p) => p.id !== action.program.id
            ),
            programList: [...s.programList, action.program],
          };
        case "REORDER_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: action.list,
          };
        case "CREATE_HIGHLIGHT":
          return {
            ...s,
            isProcessing: true,
            isError: false,
          };
        case "CREATE_HIGHLIGHT_SUCCESS":
          history.push("/shelf/");
          break;
        case "CREATE_HIGHLIGHT_ERROR":
          console.log(action.error);
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "FETCH_PROGRAM_SUCCESS":
          return {
            ...s,
            programList: action.programList,
          };
        case "SET_TITLE":
          return {
            ...s,
            title: action.title,
          };
        case "SET_CATEGORY":
          return {
            ...s,
            category: action.category,
          };
        default:
          return s;
      }
    },
    {
      programList: [],
      pickedProgramList: [],
      categoryList: [],
      title: "",
      category: "",
      isProcessing: true,
      isError: false,
    }
  );
  React.useEffect(() => {
    const f = async () => {
      try {
        const responses = await fetchHighlightFormData();
        const categoryList = responses[0].data;
        const resp = await fetchProgramByCategoryAndTitle(
          categoryList[0].id,
          ""
        );
        dispatch({
          type: "FETCH_SUCCESS",
          programList: resp.data,
          categoryList: categoryList,
        });
      } catch (e) {
        console.error(e);
        dispatch({
          type: "FETCH_ERROR",
        });
      }
    };

    f();
  }, []);

  const onSetTitle = (title) => {
    dispatch({ type: "SET_TITLE", title });
  };

  const onSetCategory = (category) => {
    dispatch({ type: "SET_CATEGORY", category });
  };

  const onPickProgram = (program) => {
    dispatch({
      type: "ADD_PICKED_PROGRAM",
      program,
    });
  };
  const onRemovePickedProgram = (program) => {
    dispatch({
      type: "REMOVE_PICKED_PROGRAM",
      program,
    });
  };
  const onReorderPickedProgram = (program, current, next) => {
    const list = state.pickedProgramList.map((p, index) => {
      if (index === next) {
        return {
          ...program,
        };
      } else if (index === current) {
        return {
          ...state.pickedProgramList[next],
        };
      } else {
        return p;
      }
    });
    dispatch({
      type: "REORDER_PICKED_PROGRAM",
      list,
    });
  };
  const onFetchPrograms = async (categoryTitle, title) => {
    console.log(categoryTitle, title);
    const category = state.categoryList.find((c) => c.title === categoryTitle);
    try {
      const resp = await fetchProgramByCategoryAndTitle(category.id, title);
      dispatch({ type: "FETCH_PROGRAM_SUCCESS", programList: resp.data });
    } catch (e) {
      console.log(e);
    }
  };
  const onSubmit = async (data) => {
    const category = state.categoryList.find((c) => c.title === data.category);
    try {
      dispatch({ type: "CREATE_HIGHLIGHT" });
      const resp = await createHighlight({
        id: category.slug,
        slug: category.slug,
        title: data.title,
        category: category.id,
        programs: state.pickedProgramList.map((p) => p.id),
      });
      if (resp.data && resp.data.name === "error") {
        throw new Error(resp.data.detail);
      }
      dispatch({ type: "CREATE_HIGHLIGHT_SUCCESS" });
    } catch (e) {
      console.log(e);
      dispatch({ type: "CREATE_HIGHLIGHT_ERROR", error: e });
    }
  };
  return (
    <Form
      categories={state ? state.categoryList : []}
      pickedPrograms={state ? state.pickedProgramList : []}
      programs={state ? state.programList : []}
      title={state ? state.title : ""}
      category={state ? state.category : ""}
      onSetTitle={onSetTitle}
      onSetCategory={onSetCategory}
      onPickProgram={onPickProgram}
      onRemovePickedProgram={onRemovePickedProgram}
      onReorderPickedProgram={onReorderPickedProgram}
      onFetchPrograms={onFetchPrograms}
      onSubmit={onSubmit}
    />
  );
}

export function HighlightDetails() {
  const history = useHistory();
  const params = useParams();
  const [state, dispatch] = React.useReducer(
    (s, action) => {
      switch (action.type) {
        case "FETCH_SUCCESS":
          const category = action.categoryList.find(
            (c) => c.id === action.highlight.category
          );
          return {
            ...s,
            highlight: action.highlight,
            category: category ? category.title : "",
            title: action.highlight.title,
            categoryList: action.categoryList,
            pickedProgramList: action.pickedProgramList
              .sort((a, b) => a.rank - b.rank)
              .map((p) => p.program),
            programList: action.programList,
            isProcessing: false,
            isError: false,
          };
        case "FETCH_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "ADD_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: [...s.pickedProgramList, action.program],
            programList: s.programList.filter(
              (p) => p.id !== action.program.id
            ),
          };
        case "REMOVE_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: s.pickedProgramList.filter(
              (p) => p.id !== action.program.id
            ),
            programList: [...s.programList, action.program],
          };
        case "REORDER_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: action.list,
          };
        case "FETCH_PROGRAM_SUCCESS":
          return {
            ...s,
            programList: action.programList,
          };
        case "SET_TITLE":
          return {
            ...s,
            title: action.title,
          };
        case "SET_CATEGORY":
          return {
            ...s,
            category: action.category,
          };
        case "UPDATE_SUCCESS":
          history.push("/shelf/");
          break;
        default:
          return s;
      }
    },
    {
      highlight: {},
      pickedProgramList: [],
      categoryList: [],
      programList: [],
      title: "",
      category: "",
      isProcessing: true,
      isError: false,
    }
  );
  React.useEffect(() => {
    const f = async () => {
      try {
        const responses = await fetchHighlightDetailsData(params.id);
        if (responses[0].data.length === 0) {
          throw new Error(`Highlight ID: ${params.id} not found.`);
        }
        const highlight = responses[0].data[0];
        const resp = await fetchAvailableProgram(
          highlight.category,
          highlight.id,
          ""
        );
        dispatch({
          type: "FETCH_SUCCESS",
          highlight: highlight,
          pickedProgramList: responses[1].data,
          categoryList: responses[2].data,
          programList: resp.data,
        });
      } catch (e) {
        console.error(e);
        dispatch({
          type: "FETCH_ERROR",
        });
      }
    };

    f();
  }, [params.id]);
  const onSetTitle = (title) => {
    dispatch({ type: "SET_TITLE", title });
  };

  const onSetCategory = (category) => {
    dispatch({ type: "SET_CATEGORY", category });
  };

  const onPickProgram = (program) => {
    dispatch({
      type: "ADD_PICKED_PROGRAM",
      program,
    });
  };
  const onRemovePickedProgram = (program) => {
    dispatch({
      type: "REMOVE_PICKED_PROGRAM",
      program,
    });
  };
  const onReorderPickedProgram = (program, current, next) => {
    const list = state.pickedProgramList.map((p, index) => {
      if (index === next) {
        return {
          ...program,
        };
      } else if (index === current) {
        return {
          ...state.pickedProgramList[next],
        };
      } else {
        return p;
      }
    });
    dispatch({
      type: "REORDER_PICKED_PROGRAM",
      list,
    });
  };
  const onFetchPrograms = async (categoryTitle, title) => {
    console.log(categoryTitle, title);
    const category = state.categoryList.find((c) => c.title === categoryTitle);
    try {
      const resp = await fetchAvailableProgram(
        category ? category.id : "",
        state.highlight.id,
        title
      );
      dispatch({ type: "FETCH_PROGRAM_SUCCESS", programList: resp.data });
    } catch (e) {
      console.log(e);
    }
  };
  const onSubmit = async () => {
    const category = state.categoryList.find((c) => c.title === state.category);
    await updateHighlight({
      title: state.title,
      category: category ? category.id : "",
      highlight: state.highlight.id,
      programs: state.pickedProgramList.map((p) => p.id),
    });
    dispatch({ type: "UPDATE_SUCCESS" });
    try {
    } catch (e) {
      console.log(e);
      dispatch({ type: "UPDATE_ERROR", error: e });
    }
  };

  return (
    <Details
      highlight={state ? state.highlight : {}}
      categories={state ? state.categoryList : []}
      pickedPrograms={state ? state.pickedProgramList : []}
      programs={state ? state.programList : []}
      title={state ? state.title : ""}
      category={state ? state.category : ""}
      onSetTitle={onSetTitle}
      onSetCategory={onSetCategory}
      onPickProgram={onPickProgram}
      onRemovePickedProgram={onRemovePickedProgram}
      onReorderPickedProgram={onReorderPickedProgram}
      onFetchPrograms={onFetchPrograms}
      onSubmit={onSubmit}
    />
  );
}

async function fetchShelfPageData() {
  const shelfRequest = axios.get(
    "/r-api/program_highlight?select=*,rank:program_highlight_rank(rank)"
  );
  return axios.all([shelfRequest]);
}

async function fetchHighlightDetailsData(id) {
  const highlightUrl = `/r-api/program_highlight?id=eq.${id}`;
  const highlightRequest = axios.get(highlightUrl);
  const programUrl = `/r-api/program_highlight_program?highlight=eq.${id}&select=rank,program(*)`;
  const programRequest = axios.get(programUrl);
  const categoryRequest = axios.get("/r-api/program_category");
  return axios.all([highlightRequest, programRequest, categoryRequest]);
}

async function fetchHighlightFormData() {
  const categoryRequest = axios.get("/r-api/program_category");
  return axios.all([categoryRequest]);
}

async function fetchProgramByCategoryAndTitle(category, title) {
  const url = `/r-api/program?deleted=eq.false&category=eq.${category}&title=like.*${title}*&order=created_at.desc&limit=15`;
  return axios.get(url);
}

async function fetchAvailableProgram(category, highlight, title) {
  const url = `/program-shelf-api/program?category=${category}&title=${title}&highlight=${highlight}`;
  return axios.get(url);
}

async function updateHighlightOrder(highlights) {
  const highlightRank = highlights.map((h) => {
    return {
      highlight: h.id,
      rank: h.rank,
    };
  });

  return axios.put("/program-shelf-api/program_highlight_rank/", highlightRank);
}

async function updateHighlight(highlight) {
  return axios.put("/program-shelf-api/program_highlight", highlight);
}

async function createHighlight(highlight) {
  return axios.post("/program-shelf-api/program_highlight", highlight);
}

async function deleteHighlight(id) {
  const url = `/program-shelf-api/program_highlight/${id}/`;
  return axios.delete(url);
}

function reorder(highlight, nextRank, highlights) {
  if (nextRank <= 1 || nextRank > highlights.length + 2) {
    return highlights;
  }
  const newHighlights = highlights.map((h) => {
    if (highlight.id === h.id) {
      return {
        ...h,
        rank: nextRank,
      };
    } else if (h.rank === nextRank) {
      return {
        ...h,
        rank: highlight.rank,
      };
    } else {
      return h;
    }
  });

  return newHighlights;
}
